angular.module('bmsApp.directives')
	.controller('UploadPhotoModalCtrl', [
		'$scope',
		'$q',
		'$timeout',
		'$modalInstance',
		'$ngBootbox',
		'FileSvc',
		'$log',
		'VisitPhotoSvc',
		'isBefore',
		'visitType',
		'visitId',
		'ConfigService',
		function (
			$scope,
			$q,
			$timeout,
			$modalInstance,
			$ngBootbox,
			FileSvc,
			$log,
			VisitPhotoSvc,
			isBefore,
			visitType,	
			visitId,
			ConfigService
		) {

			$scope.init = function () {
				$scope.visit_photo_details = [];
				$scope.processing = false;
				$scope.is_before = isBefore;
			};

			$scope.cancel = function () {
				$modalInstance.dismiss('cancel');
			};

			$scope.config = ConfigService.config;

			$scope.uiTimePickerOptions = angular.extend({}, angular.copy($scope.config.uiTimePickerOptions), {
				appendTo: '.modal-content'
			});
			$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
				options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
					parentEl: '.modal-content'
				})
			});
			$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
				storageFormat: 'YYYY-MM-DD  HH:mm:ss',
				options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
					format: 'MMMM Do YYYY',
					parentEl: '.modal-content'
				})
			});

			$scope.formvalidatorconfig = {
				submitHandler: function (form) {
					$scope.submit();
				},
				errorPlacement: function (error, element) {
					error.appendTo('#photo-errors');
				},
				errorContainer: '#photo-errors'
			};

			$scope.dropzone = {
				config: {
					url: '/api/file/upload',
					parallelUploads: 3,
					maxFileSize: 30,
					addRemoveLinks: false,
					eventHandlers: {
						success: function (file, response) {
							file.serverFilepath = response.filepath;
							if (!_.contains($scope.visit_photo_details, file.serverFilepath)) {
								let params = {
									caption: '',
									is_before: isBefore,
									photoable_id: visitId,
									photoable_type: visitType,
									file: response.file,
									file_name: response.file.original_filename,
								};
								$scope.visit_photo_details.push(params);
							}
							$timeout(function () {
								$scope.$apply();
							}, 0);
						},
						drop: function (event) {
							$scope.enableSubmit = false;
							$timeout(function () {
								$scope.$apply();
							}, 0);
						},
						queuecomplete: function () {
							$scope.enableSubmit = this.files.length ? true : false;
							$timeout(function () {
								$scope.$apply();
							}, 0);
						},
						removedfile: function (file) {
							var self = this;
							FileSvc.delete(file.serverFilepath)
								.then(function (response) {
									$scope.enableSubmit = self.files.length ? true : false;
									if (!_.contains($scope.visit_photo_details, file.serverFilepath)) {
										// $scope.visit_photo_details.push(file.serverFilepath);
									}
									$log.log('Dropzone file removed');
								}, function (error) {
									$log.error('Failed to remove dropzone file: ' + error);
								});
						}
					}
				}
			};

			$scope.submit = function () {
				$scope.processing = true;
				self.formValues = {visit_photo_detail: $scope.visit_photo_details};
				var savePromise = VisitPhotoSvc.save(self.formValues);
				savePromise
					.then(function (response) {
						$scope.processing = true;
						$modalInstance.close(response);
					});
			}

		}
	]);
